import Menu from '@mui/material/Menu';
import MenuItem, { MenuItemProps } from '@mui/material/MenuItem';

export type { MenuItemProps };
export { Menu, MenuItem };
export default Menu;
